'use client'

import { Spacer } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import { ContentLoader } from '@marketplace-web/common-components/content-loader-ui'
import { ErrorState } from '@marketplace-web/error-display/error-display-feature'
import {
  getInfoBoardPost,
  transformInfoBoardPostResponse,
} from '@marketplace-web/info-board/info-board-data'

import { InfoPost } from './InfoPost'

type Props = { postId: number }

const InfoBoardPost = ({ postId }: Props) => {
  const {
    fetch: fetchInfoBoardPost,
    transformedData: post,
    error,
    isLoading,
  } = useFetch(getInfoBoardPost, transformInfoBoardPostResponse)

  useEffect(() => {
    fetchInfoBoardPost(postId)
  }, [fetchInfoBoardPost, postId])

  if (isLoading) return <ContentLoader testId="infoboard-loader" />

  if (error) return <ErrorState />

  if (!post) return null

  return (
    <>
      <div className="u-mobiles-only">
        <Spacer size="x4-large" />
      </div>
      <div className="u-desktops-only">
        <Spacer size="x5-large" />
      </div>
      <InfoPost {...post} />
      <div className="u-mobiles-only">
        <Spacer size="x5-large" />
      </div>
      <div className="u-desktops-only">
        <Spacer size="x6-large" />
      </div>
    </>
  )
}

export default InfoBoardPost
